<template>
  <div id="EditLocationForm">
    <form action>
      <div class="modal-card fixed-width dtac-font">
        <!-- Modal Title -->
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t("form.location.title") }}</p>
        </header>
        <!-- Modal Description + Input -->
        <section class="modal-card-body" style="padding: 0 20px;">
          <div class="media">
            <div class="media-content">
              <location-map
                :isForm="true"
                :type="editType"
                @update_service_area_status="setupToken"
              />
            </div>
          </div>
        </section>
        <!-- Modal Footer -->
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <!-- Button: Close -->
          <button class="button dtac-font" @click.prevent="$emit('close')">
            {{ $t("register.form.otp.close_btn") }}
          </button>
          <!-- Button: Save -->
          <button
            class="button is-primary dtac-font"
            :disabled="isDisableSave"
            @click.prevent="saveButtonPressed"
          >
            {{ $t("register.form.otp.confirm_btn") }}
          </button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import AlertManager from "@/managers/AlertManager";
import LocationMap from "@/components/maps/LocationMap.vue";
import CustomerApiManager from "@/apis/CustomerApiManager";

export default {
  name: "EditLocationForm",
  components: {
    LocationMap
  },
  props: ["editType", "customerId"],
  data() {
    return {
      isDisableSave: true,
      newLocationToken: null
    };
  },
  methods: {
    setupToken: function(value) {
      this.isDisableSave = !value.service;
      this.newLocationToken = value.token;
    },
    saveButtonPressed: function() {
      if (this.newLocationToken) {
        const params = {
          cust_id: this.customerId,
          location_token: this.newLocationToken
        };
        this.updateRegisteredLocation(params);
      } else {
        AlertManager.showErrorSnackbar("Location Token not found");
      }
    },
    updateRegisteredLocation: async function(updateLocationParams) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });

      var updateLocationResult;
      switch (this.type) {
        case "prospect":
          updateLocationResult = await CustomerApiManager.requestUpdateProspectCustomerLocation(
            updateLocationParams
          );
          break;

        default:
          updateLocationResult = await CustomerApiManager.requestUpdateResgisteredLocation(
            updateLocationParams
          );

          break;
      }
      loadingComponent.close();

      switch (updateLocationResult.code) {
        case "0":
          AlertManager.showSuccessSnackbar(
            "Updated Registered Location Successfully"
          );
          this.$emit("update_customer_detail");
          break;

        default:
          AlertManager.showErrorSnackbar(updateLocationResult.message);
          break;
      }
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.fixed-width {
  max-width: 720px;
  padding: 0 20px;
}
</style>
